import { render, staticRenderFns } from "./mayowa_oladipupo_radixNg.vue?vue&type=template&id=cd3fad74&scoped=true&"
import script from "./mayowa_oladipupo_radixNg.vue?vue&type=script&lang=js&"
export * from "./mayowa_oladipupo_radixNg.vue?vue&type=script&lang=js&"
import style0 from "./mayowa_oladipupo_radixNg.vue?vue&type=style&index=0&id=cd3fad74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3fad74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
